/* API paths and service configuration */
export const BASE_URL = process.env.NEXT_PUBLIC_BASE_URL ?? '/api';
export const DATADOG_APM_TRACING_URLS = [
  'https://woven.avodahconnect.com',
  /https:\/\/.*\.avodahconnect\.com/,
  (url: string) => url.startsWith('https://woven.avodahconnect.com'),
  /https:\/\/.*\.woven\.avodahconnect\.com\/api\/.*/,
];
console.log('Server Started');
